









import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import {  QueryWithdrawOrder } from '@/api'
import { PriceFormat, WithdrawStatusFormat, BandCardFormat } from '@/utils/tyepconvert'

@Component({
  components: {
    VQuery,
    VTable,
  },
})
export default class VideoList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [{ title: '提现单号', param: 'withdrawCode' }]
  // 全局操作
  private queryOperation: Array<TableOperation> = []
  // 数据表头 -
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '提现单号', param: 'withdrawCode' },
    { title: '提现金额', param: 'withdrawAmount' , formatter: PriceFormat },
    { title: '手续费', param: 'feeAmount' , formatter: PriceFormat },
    { title: '提现银行', param: 'bankName' },
    { title: '提现卡号', param: 'accountNo', formatter: BandCardFormat },
    { title: '提现状态', param: 'withdrawStatus', formatter: WithdrawStatusFormat },
  ]

  public async created() {
    this.loadData()
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryWithdrawOrder(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {

    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
